var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 14,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 14,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4 10q.78-1.848 1.427-3.31C6.397 4.498 6.617 4 8.757 4h6.661c2.141 0 2.361.498 3.33 2.69Q19.395 8.151 20 10"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 18v2m12-2v2M4 10h16a2 2 0 0 1 2 2v6H2v-6a2 2 0 0 1 2-2z"
}))));
export default SvgCarinline;